import { DATABASE_MIGRATION_PHASES, DatabaseMigration } from "./types";

export type MigrationAlert = {
  severity: "error" | "info";
  title: string;
  message?: string;
};

// The operator's migration message is written for the platform team, never shown.
const ALERTS: Partial<Record<DATABASE_MIGRATION_PHASES, MigrationAlert>> = {
  [DATABASE_MIGRATION_PHASES.RUNNING]: {
    severity: "info",
    title: "Migration in progress",
    message:
      "The database restarts once during the migration; its data is kept."
  },
  [DATABASE_MIGRATION_PHASES.VERIFYING]: {
    severity: "info",
    title: "Migration in progress: verifying",
    message: "The database is starting after the migration."
  },
  [DATABASE_MIGRATION_PHASES.REINDEXING]: {
    severity: "info",
    title: "Migration in progress: rebuilding indexes"
  },
  [DATABASE_MIGRATION_PHASES.BLOCKED]: {
    severity: "info",
    title: "Migration on hold",
    message:
      "The database keeps running on its current platform version until the migration resumes."
  },
  [DATABASE_MIGRATION_PHASES.FAILED]: {
    severity: "error",
    title: "Migration did not complete",
    message: "The platform team will complete it. No action is needed from you."
  }
};

const SCHEDULED: MigrationAlert = {
  severity: "info",
  title: "Migration scheduled",
  message:
    "This database runs on an older platform version and will be migrated automatically. The migration restarts the database once and keeps its data."
};

// The phase decides, not `required`: a running, blocked or failed migration shows either way.
export const migrationAlert = (
  migration?: DatabaseMigration
): MigrationAlert | null =>
  (migration?.phase && ALERTS[migration.phase]) ||
  (migration?.required ? SCHEDULED : null);
